// @flow
import { makeStyles } from "@material-ui/styles";
export default makeStyles(() => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    marginTop: 0
  }
}), { index: 1 })